import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { AccuracyBreakdown } from "@/components/AccuracyBreakdown";

export const AdminSignalQuality = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/signals/admin/stats").then(({ data }) => setS(data)).catch(() => setS(false)); }, []);
  if (s === null) return <p className="text-sm text-slate-400 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</p>;
  if (!s) return <p className="text-sm text-red-400">Could not load signal statistics.</p>;
  const o = s.overall;
  const cards = [
    { label: "Signals issued", value: s.total_signals, color: "text-white" },
    { label: "Resolved", value: o.total, color: "text-cyan-400" },
    { label: "Hit rate", value: o.hit_rate != null ? `${o.hit_rate}%` : "—", color: "text-emerald-400" },
    { label: "Avg predicted", value: o.avg_predicted != null ? `${o.avg_predicted}%` : "—", color: "text-amber-400" },
    { label: "Stop hits", value: o.stop_hit, color: "text-red-400" },
    { label: "Expired", value: o.expired, color: "text-amber-400" },
    { label: "Taken / Skipped", value: `${s.decisions.taken} / ${s.decisions.skipped}`, color: "text-white" },
    { label: "Tracking now", value: o.pending, color: "text-cyan-400" },
  ];
  return (
    <div className="space-y-6" data-testid="admin-signal-quality">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="glass rounded-xl p-5"><p className="text-xs uppercase tracking-wider text-slate-400">{c.label}</p><p className={`font-mono-num text-3xl font-bold mt-1 ${c.color}`}>{c.value ?? "—"}</p></div>
        ))}
      </div>
      <div className="glass rounded-2xl p-5">
        <p className="text-sm font-semibold mb-1">Calibration · predicted vs realised</p>
        <p className="text-xs text-slate-400 mb-2">Bands with ≥20 resolved signals automatically adjust future probabilities (50/50 blend of predicted and realised).</p>
        <AccuracyBreakdown breakdown={s.breakdown} testId="admin-breakdown" />
        {s.breakdown?.by_side?.length > 0 && <p className="text-xs text-slate-400 mt-3 font-mono-num">{s.breakdown.by_side.map((r) => `${r.key}: ${r.hit_rate}% of ${r.total}`).join(" · ")}</p>}
      </div>
      <div className="glass rounded-2xl p-5" data-testid="admin-weekly">
        <p className="text-sm font-semibold mb-3">Weekly model quality</p>
        {s.weekly.length === 0 ? <p className="text-xs text-slate-500">No signals yet.</p> : (
          <table className="w-full text-sm"><thead><tr className="text-[10px] uppercase tracking-wider text-slate-500 text-left"><th className="py-1">Week</th><th>Signals</th><th>Resolved</th><th>Hit rate</th></tr></thead>
            <tbody>{s.weekly.map((w) => <tr key={w.week} className="border-t border-white/5 font-mono-num"><td className="py-1.5">{w.week}</td><td>{w.signals}</td><td>{w.resolved}</td><td className="text-emerald-400">{w.hit_rate != null ? `${w.hit_rate}%` : "—"}</td></tr>)}</tbody></table>
        )}
      </div>
    </div>
  );
};
